import React from 'react'

export default function Informations() {
  return (
    <div className='py-28 px-4' id='top' >


<h1 className='text-amber-500 mb-16 text-center'>Informations Légales</h1>
<h2>Identification de l'Association</h2>

<p>Nom de l'Association : Leading Danse <br />
Adresse : salle de fêtes de Neuvilly, 59360. <br />
Numéro de téléphone : 0603755840<br />
Adresse e-mail : danse.de.salon.neuvilly@gmail.com<br />


<br /><br />

Numéro SIRET : [Numéro SIRET]<br />
Code APE : [Code APE]<br />
Date de création : [Date de création]<br /><br />

<h2>Responsabilité éditoriale</h2><br />

Le directeur de la publication est : Keren-Or Almogi<br />
Adresse e-mail de contact :  danse.de.salon.neuvilly@gmail.com<br /><br />
<h2>Hébergement</h2><br />

Le site est hébergé par :<br />
Nom de l'hébergeur : IONOS<br />
Adresse de l'hébergeur : [Adresse de l'hébergeur]<br />
Numéro de téléphone de l'hébergeur : 0970 808 911<br /><br />
<h2>Propriété intellectuelle</h2>
<br />
Tous les contenus présents sur ce site, y compris, mais sans s'y limiter, les textes, images, logos, graphismes, vidéos et autres éléments multimédias, sont protégés par des droits d'auteur et des droits de propriété intellectuelle. <br /> 
Toute reproduction, distribution, modification ou utilisation de ces éléments sans autorisation écrite préalable de [Nom de l'Association] est strictement interdite.<br /><br />
<h2>Données personnelles</h2>
<br />
Conformément à la loi "Informatique et Libertés" du 6 janvier 1978 modifiée, vous disposez d'un droit d'accès, de rectification et de suppression des données vous concernant. Pour exercer ce droit, veuillez nous contacter à l'adresse suivante : [Adresse e-mail de contact].<br /><br />
<h2>6. Cookies</h2>

Ce site utilise des cookies pour améliorer votre expérience de navigation. Un cookie est un petit fichier texte stocké sur votre appareil. Vous pouvez gérer vos préférences en matière de cookies via les paramètres de votre navigateur. Pour plus d'informations sur les cookies, veuillez consulter notre [Politique de cookies](lien vers la politique de cookies).<br /><br />
<h2>Liens externes</h2>

Ce site peut contenir des liens vers d'autres sites. [Nom de l'Association] n'est pas responsable du contenu de ces sites et décline toute responsabilité concernant les informations ou les services proposés par ceux-ci.<br /><br />
<h2>Modifications des mentions légales</h2>

[Nom de l'Association] se réserve le droit de modifier ces informations légales à tout moment. Les utilisateurs sont donc invités à consulter régulièrement cette page pour être informés des éventuelles modifications.<br /><br />
<h2>Droit applicable</h2>

Les présentes mentions légales sont régies par la loi française. En cas de litige, les tribunaux de [Ville ou région] seront compétents.</p>









    </div>
  )
}
